import { lazyLoad, createIcon } from "./helpers";
import { projectRoutes, instituteRoutes, trainingRoutes, reportRoutes } from "./subRoutes";

const Dashboard = lazyLoad("Dashboard");
const Projects = lazyLoad("Projects");
const Institutes = lazyLoad("Institutes");
const Trainings = lazyLoad("Trainings");
const Calendar = lazyLoad("Calendar");
const FeedbackResponse = lazyLoad("FeedbackResponse");
const Reports = lazyLoad("Reports");

const TrainingCalendarList = lazyLoad("Calendar/TrainingCalendarList");
const FeedbackResponseList = lazyLoad("FeedbackResponse/FeedbackResponseList");
const FeedbackResponseViewer = lazyLoad("FeedbackResponse/FeedbackResponseViewer");

export const clientMainRoutes = [
    {
      path: "Dashboard",
      label: "Home",
      element: <Dashboard />,
      icon: createIcon("home"),    
      module: ["client"],
    },
    {
      path: "Projects",
      element: <Projects />,
      icon: createIcon("project"),
      children: projectRoutes,
      module: ["client"],
    },
    {
      path: "Institutes",
      element: <Institutes />,
      icon: createIcon("institute"),
      children: instituteRoutes,
      module: ["client"],
    },
    {
      path: "Trainings",
      element: <Trainings />,
      icon: createIcon("training"),
      children: trainingRoutes,
      module: ["client"],
    },
    {
      path: "Calendar",
      element: <Calendar />,
      icon: createIcon("calender"),
      children: [{ path: "", element: <TrainingCalendarList /> }],
      module: ["client"],
    },
    {
      path: "FeedbackResponse",
      label: "Feedback",
      element: <FeedbackResponse />,
      icon: createIcon("feedback"),
      children: [
        { path: "", element: <FeedbackResponseList /> },
        { path: "View", element: <FeedbackResponseViewer /> },
      ],
      module: ["client"],
    },
    {
      path: "Reports",
      element: <Reports />,
      icon: createIcon("report"),    
      children: reportRoutes,
      module: ["client"],
    },
];